<template>
  <modal
    name="contractor-modal"
    :resizable="true"
    :height="'auto'"
    :width="'100%'"
    :scrollable="true"
  >
    <!-- Toast powodzenia -->
    <div v-if="showToast" class="success-toast">
      ✓ Kontrahent został zaktualizowany!
    </div>

    <!-- Nagłówek modalu -->
    <div class="modal-header-custom">
      <div class="header-content">
        <h3 class="modal-title">
          <span v-if="contractor.type === 'company'">🏢</span>
          <span v-else>👤</span>
          {{ contractor.name }}
        </h3>
        <p class="modal-subtitle">Edycja kontrahenta</p>
      </div>
      <button class="btn-close-modal" @click="$emit('closeModal')">
        ✕
      </button>
    </div>

    <!-- Zawartość modalu -->
    <div class="modal-content-custom">
      <!-- Sekcja danych podstawowych -->
      <div class="form-section">
        <h5 class="section-title">
          <span class="section-icon">📋</span>
          Dane podstawowe
        </h5>

        <div class="form-row">
          <div class="form-group">
            <label class="form-label">Imię i nazwisko / Nazwa *</label>
            <input
              v-model="contractor.name"
              type="text"
              class="form-input"
              placeholder="Nazwa"
            />
          </div>

          <div class="form-group">
            <label class="form-label">Numer telefonu</label>
            <input
              v-model="contractor.phoneNumber"
              type="text"
              class="form-input"
              placeholder="Numer telefonu"
            />
          </div>
        </div>

        <div class="form-row">
          <div class="form-group">
            <label class="form-label">Adres</label>
            <input
              v-model="contractor.address"
              type="text"
              class="form-input"
              placeholder="Adres"
            />
          </div>

          <div class="form-group">
            <label class="form-label">Email</label>
            <input
              v-model="contractor.email"
              type="email"
              class="form-input"
              placeholder="Email"
            />
          </div>
        </div>

        <div v-if="contractor.type === 'company'" class="form-row">
          <div class="form-group">
            <label class="form-label">NIP</label>
            <input
              v-model="contractor.nip"
              type="text"
              class="form-input"
              placeholder="NIP"
            />
          </div>

          <div class="form-group">
            <label class="form-label">Osoba kontaktowa</label>
            <input
              v-model="contractor.contactPerson"
              type="text"
              class="form-input"
              placeholder="Osoba kontaktowa"
            />
          </div>
        </div>
      </div>

      <!-- Sekcja instalacji -->
      <div class="form-section" v-if="contractorInstalations.length > 0">
        <h5 class="section-title">
          <span class="section-icon">🔧</span>
          Lista instalacji ({{ contractorInstalations.length }})
        </h5>

        <div class="installations-grid">
          <div 
            v-for="item in contractorInstalations" 
            :key="item.id"
            class="installation-card"
          >
            <div class="card-header">
              <span class="card-icon">🔧</span>
              <span class="card-title">Instalacja</span>
            </div>
            <div class="card-body">
              <div class="card-item">
                <span class="item-icon">📅</span>
                <div class="item-content">
                  <span class="item-label">Montaż</span>
                  <span class="item-value">{{ item.date }}</span>
                </div>
              </div>
              <div class="card-item" v-if="item.serialNumber">
                <span class="item-icon">🔢</span>
                <div class="item-content">
                  <span class="item-label">Nr urządzenia</span>
                  <span class="item-value">{{ item.serialNumber }}</span>
                </div>
              </div>
              <div class="card-item" v-if="item.service">
                <span class="item-icon">🔧</span>
                <div class="item-content">
                  <span class="item-label">Serwis</span>
                  <span class="item-value">{{ item.service }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Sekcja uwag -->
      <div class="form-section">
        <h5 class="section-title">
          <span class="section-icon">📝</span>
          Uwagi
        </h5>

        <div class="form-group">
          <textarea
            v-model="contractor.notice"
            class="form-textarea"
            rows="5"
            placeholder="Dodatkowe uwagi o kontrahencie..."
          ></textarea>
        </div>
      </div>
    </div>

    <!-- Fixed footer -->
    <div class="modal-footer-custom">
      <div class="footer-left"></div>
      <div class="footer-center">
        <button 
          v-if="contractor.type === 'company'"
          class="btn-submit" 
          @click="updateCompany"
        >
          <span class="submit-icon">✓</span>
          Zapisz zmiany
        </button>
        <button 
          v-else
          class="btn-submit" 
          @click="updateCustomer"
        >
          <span class="submit-icon">✓</span>
          Zapisz zmiany
        </button>
        <button class="btn-cancel" @click="$emit('closeModal')">
          Anuluj
        </button>
      </div>
      <div class="footer-right">
        <button class="btn-delete" @click="deleteContractor">
          <span class="delete-icon">🗑️</span>
          Usuń kontrahenta
        </button>
      </div>
    </div>
  </modal>
</template>
<script>
import { mapState } from "vuex";
export default {
    
   props: ["contractor"],
        

  data() {
    return {
      contractorChecked: {},
      showToast: false,
    };
  },
  computed: {
    ...mapState(["userProfile","installations", "contractorUpdated"]),
    contractorInstalations(){
      return this.installations.filter((item) => {
        return item.contractor.id.includes(this.contractor.id);
      });
    },
    contractorAddress(){
      if(!this.contractor.address){
        return "-"
      } else {
        return this.contractor.address
      }
    },
    contractorPhoneNumber(){
      if(!this.contractor.phoneNumber){
        return "-"
      } else {
        return this.contractor.phoneNumber
      }
    }
    ,
    contractorEmail(){
      if(!this.contractor.email){
        return "-"
      } else {
        return this.contractor.email
      }
    },
    test(){
      
      return this.contractor.id
    }
    ,
    contractorNip(){
      if(!this.contractor.nip){
        return "-"
      } else {
        return this.contractor.nip
      }
    }
   
    
  },
  
  methods: {
    updateCompany(){
      this.$store
        .dispatch("updateCompany", {
          id: this.contractor.id,
          address: this.contractor.address,
          notice: this.contractor.notice,
          email: this.contractorEmail,
          contactPerson: this.contractor.contactPerson,
          name: this.contractor.name,
          nip: this.contractorNip,
          phoneNumber: this.contractorPhoneNumber,
        })
        .then(() => {
          this.showToast = true;
          this.$emit("contractorUpdated");
          setTimeout(() => {
            this.showToast = false;
            this.$emit("closeModal");
          }, 2000);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    updateCustomer(){
      this.$store
        .dispatch("updateCustomer", {
          id: this.contractor.id,
          address: this.contractor.address,
          notice: this.contractor.notice,
          email: this.contractorEmail,
          name: this.contractor.name, 
          phoneNumber: this.contractorPhoneNumber,
        })
        .then(() => {
          this.showToast = true;
          this.$emit("contractorUpdated");
          setTimeout(() => {
            this.showToast = false;
            this.$emit("closeModal");
          }, 2000);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    deleteContractor(){
       if (
        confirm("Czy jesteś pewien ze chcesz usunąć kontrahenta?")
      ) {
        this.$store.dispatch("deleteContractor", {
          id: this.contractor.id,
        });
      } else {
        console.log("Contractor Deleted.");
      }
    }


  }
};
</script>

<style scoped>
/* --- Toast notification --- */
.success-toast {
  position: fixed;
  top: 20px;
  right: 20px;
  background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
  color: white;
  padding: 16px 24px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(17, 153, 142, 0.3);
  font-weight: 500;
  z-index: 10000;
  animation: slideIn 0.3s ease;
}

@keyframes slideIn {
  from {
    transform: translateX(400px);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

/* --- Nagłówek modalu --- */
.modal-header-custom {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 24px 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid #f0f0f0;
}

.header-content {
  flex: 1;
}

.modal-title {
  color: white;
  font-size: 24px;
  font-weight: 700;
  margin: 0 0 4px 0;
  display: flex;
  align-items: center;
  gap: 8px;
}

.modal-subtitle {
  color: rgba(255, 255, 255, 0.9);
  font-size: 14px;
  margin: 0;
}

.btn-close-modal {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: none;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  font-size: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-close-modal:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: rotate(90deg);
}

/* --- Zawartość modalu --- */
.modal-content-custom {
  padding: 32px;
  padding-bottom: 120px;
  max-height: calc(100vh - 300px);
  overflow-y: auto;
}

/* --- Sekcje formularza --- */
.form-section {
  margin-bottom: 32px;
  padding-bottom: 32px;
  border-bottom: 2px solid #f0f0f0;
}

.form-section:last-of-type {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.section-icon {
  font-size: 20px;
}

/* --- Form elements --- */
.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-label {
  font-size: 14px;
  font-weight: 600;
  color: #4a5568;
  margin-bottom: 8px;
}

.form-input {
  padding: 12px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 15px;
  transition: all 0.3s ease;
}

.form-input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.form-input::placeholder {
  color: #a0aec0;
}

.form-textarea {
  padding: 12px 16px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 15px;
  font-family: inherit;
  resize: vertical;
  transition: all 0.3s ease;
}

.form-textarea:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.form-textarea::placeholder {
  color: #a0aec0;
}

/* --- Grid instalacji --- */
.installations-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
}

.installation-card {
  background: white;
  border-radius: 12px;
  border: 2px solid #e2e8f0;
  overflow: hidden;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.installation-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.15);
  border-color: #667eea;
}

.card-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.card-icon {
  font-size: 18px;
}

.card-title {
  font-size: 14px;
  font-weight: 600;
  color: white;
}

.card-body {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.card-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.item-icon {
  font-size: 18px;
  margin-top: 2px;
}

.item-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.item-label {
  font-size: 11px;
  color: #718096;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.item-value {
  font-size: 14px;
  color: #2c3e50;
  font-weight: 600;
}

/* --- Fixed footer --- */
.modal-footer-custom {
  position: sticky;
  bottom: 0;
  background: white;
  border-top: 2px solid #f0f0f0;
  padding: 20px 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.05);
}

.footer-left,
.footer-center,
.footer-right {
  flex: 1;
  display: flex;
  align-items: center;
}

.footer-center {
  justify-content: center;
  gap: 12px;
}

.footer-right {
  justify-content: flex-end;
}

/* --- Przyciski --- */
.btn-submit {
  padding: 14px 28px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
  display: flex;
  align-items: center;
  gap: 8px;
}

.btn-submit:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4);
}

.submit-icon {
  font-size: 16px;
}

.btn-cancel {
  padding: 12px 24px;
  background: white;
  color: #718096;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-cancel:hover {
  background: #f8f9fa;
  border-color: #cbd5e0;
  color: #4a5568;
}

.btn-delete {
  padding: 12px 24px;
  background: white;
  color: #e53e3e;
  border: 2px solid #fc8181;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.btn-delete:hover {
  background: #fff5f5;
  border-color: #e53e3e;
  color: #c53030;
}

.delete-icon {
  font-size: 16px;
}

/* --- Responsywność --- */
@media (max-width: 768px) {
  .modal-header-custom {
    padding: 16px 20px;
  }

  .modal-title {
    font-size: 20px;
  }

  .modal-content-custom {
    padding: 20px;
    padding-bottom: 140px;
  }

  .form-row {
    grid-template-columns: 1fr;
  }

  .modal-footer-custom {
    flex-direction: column;
    gap: 12px;
    padding: 16px 20px;
  }

  .footer-left,
  .footer-center,
  .footer-right {
    width: 100%;
    justify-content: center;
  }

  .footer-center {
    flex-direction: column;
  }

  .btn-submit,
  .btn-cancel,
  .btn-delete {
    width: 100%;
    justify-content: center;
  }
}
</style>